import { useLang } from "@/lib/i18n";
import { FAQS } from "@/content/faq";
import Seo from "@/components/shared/Seo";
import PageHero from "@/components/shared/PageHero";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function Faq() {
  const { t, code } = useLang();
  return (
    <>
      <Seo title={t("faq.title")} description={t("faq.subtitle")} />
      <PageHero eyebrow={t("nav.faq")} title={t("faq.title")} subtitle={t("faq.subtitle")} tone="yellow" />

      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="overflow-hidden rounded-3xl border-2 border-[#147DEB]/10 bg-white px-6" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display text-left text-lg font-bold text-[#082B66] hover:no-underline">
                {f.q[code]}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-[#475569]">
                {f.a[code]}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </>
  );
}
